export default __webpack_public_path__ + "static/media/BLAZE-Logo-white.0268512f.svg";